import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useDrainSlitComplaintReportStore } from "./useDrainSlitComplaintReportStore";

const HEADERS = [
  "S.No",
  "Complaint No",
  "Contact No",
  "Name",
  "Ward",
  "Colony",
  "Status",
  "Created At",
  "Resolved At",
  "Duration",
  "Closed By",
];

const mapRow = (row, index) => [
  index + 1,
  row.complaintNo || "N/A",
  row.contactNo || "N/A",
  row.complainantName || "N/A",
  row.wardName || "N/A",
  row.colonyName || "N/A",
  row.status || "N/A",
  row.complaintDate || "N/A",
  row.closedDate || "N/A",
  row.actualDuration || "N/A",
  row.closedBy || "N/A",
];

const ExportDrainSlitComplaintPdf = () => {
  const { drainSlitComplaintOuterReport, filters } =
    useDrainSlitComplaintReportStore();

  const downloadPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    const dateRange =
      filters?.FromDate && filters?.ToDate
        ? `(${filters.FromDate} to ${filters.ToDate})`
        : "";
    const reportTitle = `Drain Slit Complaints Report ${dateRange}`;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text(reportTitle, doc.internal.pageSize.getWidth() / 2, 12, {
      align: "center",
    });

    autoTable(doc, {
      head: [HEADERS],
      body: (drainSlitComplaintOuterReport || []).map(mapRow),
      startY: 20,
      theme: "striped",
      headStyles: {
        fillColor: [4, 53, 85],
        textColor: [255, 255, 255],
        halign: "center",
        fontSize: 8,
      },
      bodyStyles: { halign: "center", fontSize: 7 },
      styles: { overflow: "linebreak" },
    });

    doc.save("DrainSlitComplaintsReport.pdf");
  };

  return (
    <button type="button" className="btn btn-excel" onClick={downloadPDF}>
      <i className="fa-solid fa-file-pdf me-1 icon-container"></i> PDF
    </button>
  );
};

export default ExportDrainSlitComplaintPdf;
